import { LoaderFileKeys } from "../constant/AppConstants";
import { LabelButton } from "../../ui/LabelButton";
import { TablePopupWindow } from "./TablePopupWindow";
import { AppSettings } from "../managers/AppSettings";
import { RectSize } from "../../utils/RectSize";
import { IInteractive } from "../../interfaces/IInteractive";
import { ButtonBase } from "../../ui/ButtonBase";
import { AppLocalization } from "../localization/AppLocalization";
import { Padding } from "../../utils/Padding";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { PopupWindow } from "./PopupWindow";
import { LayoutDataManager, OptionsItemKeys } from "../managers/LayoutDataManager";
import { TextBubble } from "../ui/TextBubble";
import { TableScreen } from "../screen/TableScreen";
import { Players, ReorderCardsProps } from "../player/Players";
import { Player } from "../player/Player";
import { ScreenManager } from "../../managers/ScreenManager";
import { Card } from "../card/Card";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { OptionsItemLiveData } from "../../types/types";
import { HintBubble } from "../ui/HintBubble";
import { TablePhase } from "../state/TableStateMachine";


export class PopupHint extends PopupWindow {
    public nsContentBg: Phaser.GameObjects.NineSlice;
    public nsContentBgExtrusion: number = 25; // extrude to cover for outer drop shadow size
    public txtTitle: Phaser.GameObjects.Text;
    public bubble: HintBubble;

    protected interactives: IInteractive[];
    protected padding: Padding;

    private table: TableScreen;


    public override Init(table?: TableScreen): void {
        // >> create screenOverlayHitArea
        super.Init();

        this.table = table;

        this.padding = new Padding(40);
    }

    public override Build(): void {
        // console.log("PopupHints::Build");

        // > imgScreenOverlay
        // super.Build();

        // override overlay transparency
        // EDIT: no overlay = allow clicks
        // this.imgScreenOverlay.alpha = 0.0;

        // speech bubble
        this.bubble = new HintBubble(this.scene);
        this.bubble.Init(
            {texture: LoaderFileKeys.ui, frame: "rect-white-w36-r12-ds.png"},
            21,
            {texture: LoaderFileKeys.ui, frame: "bubble-triangle.png"},
            new Padding(9)
        );
        this.bubble.Build();
        this.bubble.SetOrigin(0.5, 1);
        this.bubble.Hide(false);
        this.add(this.bubble);
    }

    public SetText(sText: string): void {
        this.bubble.SetText(sText);
        this.bubble.UpdateView();
    }

    public override Show(animated: boolean = true): void {
        this.bubble.Show(animated);
        this.visible = true;
    }

    public override Hide(animated: boolean = true): void {
        this.bubble.Hide(animated, this.OnHideComplete.bind(this));
    }

    private OnHideComplete(): void {
        this.visible = false;
    }

    public override OnResize(windowRect?: RectSize): void {
        // hint popup orientation depends on TablePhase (BIDDING|PLAY)
        const tablePhase = this.table.GetStateMachine().GetTablePhase();
        // console.log(TablePhase[tablePhase]);

        if (windowRect == undefined) {
            windowRect = ScreenManager.GetWindowRect();
        }

        // > imgScreenOverlay
        if (this.imgScreenOverlay) {
            super.OnResize(windowRect);
        }

        const contentScale = ScreenManager.GetAssetScale(1.0, 0.8);
        const screenOrientationType: ScreenOrientationType = ScreenManager.GetOrientation();

        const player: Player = this.table.players.GetPlayerByIndex(Players.PLAYER_INDEX);

        let popupCardsHeight: number = 0;
        let poppedCards: Card[] = this.table.players.GetPlayerByIndex(Players.PLAYER_INDEX).GetCurPoppedCards();
        const poppedCardsCount: number = poppedCards == undefined ? 0 : poppedCards.length;
        let cardsProps: ReorderCardsProps;
        if (poppedCardsCount > 0) {
            cardsProps = this.table.players.GetPlayerByIndex(Players.PLAYER_INDEX).GetCardsProps();
        }

        // NOTE: the only thing that scales in terms of car scale is cardsContainer.
        // NOTE: could use player.cardsContainer?.getAt(0) to determine height, but unreliable until cards in hand
        // const cardDisplayHeight = (player.cardsContainer?.getAt(0) as Card)?.view.displayHeight ?? 1;
        const cardDisplayHeight = AppSettings.general.cardHeight ?? 384;

        // NOTE: Player resize runs before this (GOOD)
        let cardsScreenEdgeOffset: number;
        switch (screenOrientationType) {
            case ScreenOrientationType.LANDSCAPE:
                if (tablePhase == TablePhase.BIDDING) {
                    this.bubble.SetFacingGrowingLeft(false);
                    this.bubble.setPosition(
                        windowRect.width * 0.5 + this.bubble.GetFacing().x * 48 * player.avatarContainer.scale,
                        windowRect.height - (player.avatar.displayHeight - 40) * player.avatarContainer.scale,
                    );
                    this.bubble.SetTextWordWrap(windowRect.width * 0.5 - 155 * contentScale, true);
                }
                else {
                    cardsScreenEdgeOffset = player.GetPlayerProps().cardsContainer.landscape.screenEdgeOffset;
                    if (poppedCardsCount > 0) {
                        popupCardsHeight = cardsProps.portrait.cardsCirclePosition.y - cardsProps.portrait.poppedCardsCirclePosition.y;
                    }
                    this.bubble.SetFacingGrowingUp(false);
                    this.bubble.setPosition(
                        windowRect.width * 0.5,
                        windowRect.height - (cardDisplayHeight * 0.5 + cardsScreenEdgeOffset + 50 + popupCardsHeight) * player.cardsContainer.scale,
                    );
                    this.bubble.SetTextWordWrap(windowRect.width - 200 * contentScale, true);
                }
                break;

            case ScreenOrientationType.PORTRAIT:
                cardsScreenEdgeOffset = player.GetPlayerProps().cardsContainer.portrait.screenEdgeOffset;
                if (poppedCardsCount > 0) {
                    popupCardsHeight = cardsProps.portrait.cardsCirclePosition.y - cardsProps.portrait.poppedCardsCirclePosition.y;
                }
                this.bubble.SetFacingGrowingUp(false);
                this.bubble.setPosition(
                    windowRect.width * 0.5,
                    windowRect.height - (cardDisplayHeight * 0.5 + cardsScreenEdgeOffset + 50 + popupCardsHeight) * player.cardsContainer.scale,
                );
                this.bubble.SetTextWordWrap(windowRect.width - 200 * contentScale, true);
                break;
        }
        

        this.bubble.SetFontSize(this.bubble.GetBaseFontSize() * contentScale);
        this.bubble.UpdateView();
    }
}